export const development: boolean = import.meta.env.DEV;

// Runtime config từ /config.js (mount volume theo từng deployment prebuild) — ưu tiên;
// fallback build-time VITE_* (dev local / khi chưa mount config.js).
const RT = (typeof window !== 'undefined' && window.__ENV__) || {};

export const baseUrl = RT.API_URL || import.meta.env.VITE_DEV_API; // URL BE
export const KIOS_STORAGE = RT.KIOS_LOGOS || import.meta.env.VITE_KIOS_LOGOS || ''; // kios storage url
export const APP_MAP_KEY = RT.MAP_KEY || import.meta.env.VITE_APP_MAP_KEY || ''; // vietmap API key
export const TERM_OF_SERVICE_URL =
  RT.TERM_OF_SERVICE_URL || import.meta.env.VITE_TERM_OF_SERVICE_URL; // term of service url

export const API_PATHS = {
  hdsd: {
    list: 'setting/user-manuals',
  },
};
